import Web2CaseForm from '@/components/Forms/Web2CaseForm';
import { Layout } from '@/components/Layout/Layout';
import { ANONYMOUS_TOKEN_NAME, LOCALE_DEFAULT } from 'config/config';
import type { GetServerSideProps } from 'next';
import Head from 'next/head';
import { SupportPageController } from 'server/controller/page/support/supportPageController';
import type { ISupportPageResource } from 'server/resource/page/supportPageResource';

const RootPage = (props: ISupportPageResource) => {
  const {
    metaData,
    data,
    footerNavData,
    footerImage,
    locale,
    searchOverlayData,
    countrySelectorData,
    newsletterData,
    contactUsUrl,
    difficultyCopy,
    getHeaderNav,
    getMobileNavData,
    popularSearchData,
    cardCarouselCMSData,
    recallData,
    pathTranslations,
    userToken,
    globalDictionary,
  } = props;

  return (
    <>
      <Head>
        <meta name="robots" content="noindex,nofollow" />
      </Head>
      <Layout
        themeName={data?.genericPages.at(0)?.theme || ''}
        pathTranslations={pathTranslations}
        locale={locale}
        globalMetadata={null}
        getHeaderNav={getHeaderNav}
        getMobileNavData={getMobileNavData}
        popularSearchData={popularSearchData}
        footerNavData={footerNavData}
        footerImage={footerImage}
        searchOverlayData={searchOverlayData}
        countrySelectorData={countrySelectorData}
        newsletterData={newsletterData}
        contactUsUrl={contactUsUrl}
        difficultyCopy={difficultyCopy as Record<string, string>}
        cardCarouselCMSData={cardCarouselCMSData}
        recallData={recallData}
        userToken={userToken}
        globalDictionary={globalDictionary}
      >
        <div className="container mx-auto my-10 max-w-3xl">
          <Web2CaseForm locale={locale} />
        </div>
      </Layout>
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async ({
  locale,
  params,
  defaultLocale,
  resolvedUrl,
  req,
  res,
}) => {
  if (locale !== 'de_DE') {
    res.statusCode = 404;
  }

  const anonymousToken = req.cookies[ANONYMOUS_TOKEN_NAME];
  return SupportPageController.getContactFormPageData({
    resolvedUrl,
    locale: locale || defaultLocale || LOCALE_DEFAULT,
    slug: Array.isArray(params?.slug) ? params.slug : [],
    userToken: anonymousToken ?? '',
  });
};

export default RootPage;
